import queryString from './query-string';
import { isInMiniProgram } from './development';
import { bbtNative } from '@bbtfe/webview-bridge';
import browserClient from '@apmplus/web';
import { projectId } from '../project';
import { processEnv } from './config';

const getUid = () => {
  const query = queryString.parseUrl(window.location.href)?.query;
  if (bbtNative.isApp()) {
    return query?.['enc-user-id'];
  }
  if (isInMiniProgram()) {
    return query?.token || '';
  }
  return '';
};

const env = {
  local: 'dev',
  test: 'test',
  online: 'production'
}[processEnv.hostEnv];
if (['test', 'production'].includes(env)) {
  browserClient('init', {
    aid: 355133,
    env,
    release: projectId + processEnv.buildVersion,
    userId: getUid(),
    plugins: {
      blankScreen: {
        rootSelector: '#app'
      }
    }
  });
  browserClient('start');
  browserClient('on', 'beforeSend', event => {
    return event?.common?.pid == '/h5_fe_shop/html/' ? false : event;
  });
}
